import React, { useEffect, useRef, useState } from "react";

// Smooth count-up for numbers. Respects small deltas.
export default function CountUp({ value, duration = 1200, className, style, decimals = 0 }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef();

  useEffect(() => {
    const start = performance.now();
    const from = 0;
    const to = Number(value) || 0;
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setDisplay(from + (to - from) * ease(p));
      if (p < 1) ref.current = requestAnimationFrame(tick);
    };
    ref.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(ref.current);
  }, [value, duration]);

  return <span className={className} style={style}>{display.toFixed(decimals)}</span>;
}
